import Organization from '@/api/Organization'
import store from '@/store'
import Permission from '@/classes/Permission'

class Configuration {

  static async setOrganizationConfig(user){
    let organization = new Organization()
    let org_id = user.organization_id
    let params = {}
    return new Promise((resolve,reject)=>{
      organization.configuration(org_id,params).then((org)=>{
        var allowedCrm = false
        let permission = Permission.loadPermissions()
        var allowedCrm = Permission.can(permission, "is_admin")
        if(allowedCrm) {
          organization.crm(org_id,params).then((crm)=>{
            let mappedOrg = Configuration.mapConfiguration(org)
            if(crm || user.role === 'root'){
              mappedOrg.crm_presence = {configuration_type: 'ui', content: true}
            }else{
              mappedOrg.crm_presence = {configuration_type: 'ui', content: false}
            }
            store.commit('SET_CURRENT_ORG_CONFIG', mappedOrg)
            resolve(mappedOrg)
         })
        }
      }).catch(e=>{
        reject(e)
      })
    })
  }

  static mapConfiguration(configuration){
    let output = {}
    configuration.forEach((value,key)=>{
      output[value['key']] = {
        content: value['content'], 
        configuration_type: value['configuration_type']
      }
    })
    return output
  }
}

export default Configuration


// WEBPACK FOOTER //
// ./src/classes/Configuration.js